var archive = {
    bindings : {
        moreLabel : '@',
        archiveLabel : '@',
        archiveHref : '@'
    },
    controller : function ArchiveCtrl ($element, DataService) {
        function init () {
            ctrl.limit = 6;
        }

        function link () {
        }

        function constructByline (contributors) {
            var names = [];
            _.each(contributors, function addContributorName (contributor, i) {
                names[names.length] = contributor.contributor_name;
            });
            return names.join(', ');
        }

        function onGetArchiveSuccess (response) {
            console.log("onGetArchiveSuccess", response);
            data = response.data;
            ctrl.items = response.data.posts;
        }

        function onGetArchiveSuccess (response) {
            console.log("onGetArchiveSuccess", response);
            data = response.data;
            ctrl.items = [];
            _.each(response.data.posts, function createItem (post) {
                if (post.contributors && post.contributors.length > 0) {
                    post.byline = constructByline(post.contributors);
                    post.bylinePrefix = (wpmlLang === 'da') ? 'af: ': 'by: ';
                }
                ctrl.items.push(post);
            });
        }

        function onGetArchiveError (error) {
            console.log("onGetArchiveError", error);
        }

        function onWindowScroll (event) {

            if ( !ctrl.items ) {
                var scrollTop = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop; // For ie 11
                if (($element[0].offsetTop - scrollTop) < window.innerHeight) {
                    window.removeEventListener('scroll', onWindowScroll);
                    DataService.getArchive('post', 15)
                        .then(onGetArchiveSuccess, onGetArchiveError);   
                }
                else {
                    // HEJ
                }            
            }

        }

        var ctrl = this;
        var data;

        this.showMore = function () {
            ctrl.limit += 3;
        }

        this.$onInit = init;
        this.$postLink = link;

        window.addEventListener('scroll', onWindowScroll);
        onWindowScroll();
    },
    templateUrl : themeUrl + '/assets/static/html/archive.component.html?v=' + assetVersion,
};